/**
 * Live feedback, computed from the clues and the drawn edges alone (CLAUDE.md §10): the loop
 * of the answer key never reaches this code.
 */
import type { Feedback } from "../types";
import { contradictions } from "./loop";
import { cellId, edgeKey, type SlitherlinkDefinition, type SlitherlinkProgress } from "./types";
import { resizeEdges } from "./progress";

export const CLUE_CONTRADICTION = "clue_contradiction";
export const DOT_CONTRADICTION = "dot_contradiction";
export const PREMATURE_LOOP = "premature_loop";

export function liveContradictions(
  definition: SlitherlinkDefinition,
  progress: SlitherlinkProgress,
) {
  return contradictions(
    definition.clues,
    resizeEdges(progress, definition.rows, definition.cols),
    definition.rows,
    definition.cols,
  );
}

export function localFeedback(
  definition: SlitherlinkDefinition,
  progress: SlitherlinkProgress,
): Feedback[] {
  const found = liveContradictions(definition, progress);
  const feedback: Feedback[] = [
    ...found.clues.map(([r, c]) => ({
      type: "clue",
      code: CLUE_CONTRADICTION,
      cells: [cellId(r, c)],
    })),
    ...found.dots.map(([r, c]) => ({
      type: "dot",
      code: DOT_CONTRADICTION,
      cells: [`d${r}c${c}`],
    })),
  ];
  if (found.loop.length > 0)
    feedback.push({ type: "loop", code: PREMATURE_LOOP, cells: found.loop.map(edgeKey) });
  return feedback;
}
